import { topologyLevels } from '@constants/index';
import {
  PLANNER_DPP_CLICKED,
  PLANNER_PRACTICE_CLICKED,
  BATCH_DPP_CLICKED,
  BATCH_PRACTICE_CLICKED,
  COURSE_DPP_CLICKED,
  COURSE_PRACTICE_CLICKED
} from '@constants/segment';
import isEmptyObject from '@utils/isEmptyObject';
import { formatTime } from '@utils/dates';

export const getDppMoreEventProps = ({
  lesson,
  lessonTitle,
  goalUID,
  goalName,
  lastPrimarySourceSection
}) => {
  const author = lesson?.author || {};
  return {
    goal_uid: goalUID || '',
    goal_name: goalName || '',
    lesson_uid: lesson?.uid || '',
    lesson_title: lessonTitle || '',
    educator_uid: author.uid || '',
    educator_username: author.username || '',
    last_primary_source_section: lastPrimarySourceSection || ''
  };
};

export const getDppMoreClickEvents = (source) => {
  if (source === 'Planner') {
    return {
      dpp: PLANNER_DPP_CLICKED,
      practice: PLANNER_PRACTICE_CLICKED
    };
  }
  if (source === 'Batch') {
    return {
      dpp: BATCH_DPP_CLICKED,
      practice: BATCH_PRACTICE_CLICKED
    };
  }
  return {
    dpp: COURSE_DPP_CLICKED,
    practice: COURSE_PRACTICE_CLICKED
  };
};

export const plannerClassFetcherOptions = {
  useCamelCase: false,
  headers: {
    'X-Direct-To': 'sheldon',
    'X-PAGE': 'PLANNER'
  }
};

export const COMPLETED_STATUS = 1;
export const INCOMPLETE_STATUS = 0;

const getPrimaryTopicGroup = (lesson) => {
  const topicGroups = (lesson?.topicGroups || [])
    .map((group) => group?.topology || group)
    .filter((group) => group?.name);
  return (
    topicGroups.find((group) => group.level === topologyLevels.GROUP) ||
    topicGroups[0]
  );
};

export const getSubjectName = (lesson) =>
  getPrimaryTopicGroup(lesson)?.name || '';

export const getSubjectColor = (lesson) =>
  getPrimaryTopicGroup(lesson)?.color || '';

export const getSubjectUid = (lesson) => getPrimaryTopicGroup(lesson)?.uid;

export const getLiveAtLabel = (lesson) => {
  const { liveAt } = lesson || {};
  if (!liveAt) return '';
  const date = new Date(liveAt);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  return `${day} ${month} · ${formatTime(liveAt).toLowerCase()}`;
};

export const getParentName = (lesson) => lesson?.collectionName || '';

export const normalizePracticeDpp = (practiceDpp) => {
  if (!practiceDpp || isEmptyObject(practiceDpp)) return null;
  return {
    status: practiceDpp.status,
    sessionUid: practiceDpp.sessionUid,
    numQuestions: practiceDpp.numQuestions,
    solvedQuestions: practiceDpp.solvedQuestions ?? 0,
    uid: practiceDpp.uid,
    topicGroupUid: practiceDpp.topicGroupUid,
    goalSlug: practiceDpp.goalSlug
  };
};

export const normalizePlannerQuiz = (quiz) => {
  if (!quiz || isEmptyObject(quiz)) return null;
  return {
    status: quiz.status,
    sessionUid: quiz.session_uid,
    numQuestions: quiz.num_questions,
    solvedQuestions: quiz.solved_questions ?? 0,
    uid: quiz.uid,
    topicGroupUid: quiz.topic_group_uid,
    goalSlug: quiz.goal_slug
  };
};
